import { render, staticRenderFns } from "./TeachCapacitationsTopics.vue?vue&type=template&id=2785cada&"
import script from "./TeachCapacitationsTopics.vue?vue&type=script&lang=js&"
export * from "./TeachCapacitationsTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports